import axios from 'axios';
import Auth from '../../auth/auth';

export const dataDictionaryActions = {
  GET_SCHEMA_REQUEST: 'GET_SCHEMA_REQUEST',
  GET_SCHEMA_SUCCESS: 'GET_SCHEMA_SUCCESS',
  GET_SCHEMA_FAILURE: 'GET_SCHEMA_FAILURE',

  GET_FULL_SCHEMA_REQUEST: 'GET_FULL_SCHEMA_REQUEST',
  GET_FULL_SCHEMA_PROGRESS: 'GET_FULL_SCHEMA_PROGRESS',
  GET_FULL_SCHEMA_SUCCESS: 'GET_FULL_SCHEMA_SUCCESS',
  GET_FULL_SCHEMA_FAILURE: 'GET_FULL_SCHEMA_FAILURE',

  SAVE_DICTIONARY_REQUEST: 'SAVE_DICTIONARY_REQUEST',
  SAVE_DICTIONARY_SUCCESS: 'SAVE_DICTIONARY_SUCCESS',
  SAVE_DICTIONARY_FAILURE: 'SAVE_DICTIONARY_FAILURE',

  LOAD_DICTIONARY_LIST_REQUEST: 'LOAD_DICTIONARY_LIST_REQUEST',
  LOAD_DICTIONARY_LIST_SUCCESS: 'LOAD_DICTIONARY_LIST_SUCCESS',
  LOAD_DICTIONARY_LIST_FAILURE: 'LOAD_DICTIONARY_LIST_FAILURE',

  DELETE_DICTIONARY_REQUEST: 'DELETE_DICTIONARY_REQUEST',
  DELETE_DICTIONARY_SUCCESS: 'DELETE_DICTIONARY_SUCCESS',
  DELETE_DICTIONARY_FAILURE: 'DELETE_DICTIONARY_FAILURE',

  LOAD_DICTIONARY_DETAILS_REQUEST: 'LOAD_DICTIONARY_DETAILS_REQUEST',
  LOAD_DICTIONARY_DETAILS_SUCCESS: 'LOAD_DICTIONARY_DETAILS_SUCCESS',
  LOAD_DICTIONARY_DETAILS_FAILURE: 'LOAD_DICTIONARY_DETAILS_FAILURE',

  UPDATE_DICTIONARY_INSTANCE_REQUEST: 'UPDATE_DICTIONARY_INSTANCE_REQUEST',
  UPDATE_DICTIONARY_INSTANCE_SUCCESS: 'UPDATE_DICTIONARY_INSTANCE_SUCCESS',
  UPDATE_DICTIONARY_INSTANCE_FAILURE: 'UPDATE_DICTIONARY_INSTANCE_FAILURE',

  IMPORT_SCHEMA_REQUEST: 'IMPORT_SCHEMA_REQUEST',
  IMPORT_SCHEMA_SUCCESS: 'IMPORT_SCHEMA_SUCCESS',
  IMPORT_SCHEMA_FAILURE: 'IMPORT_SCHEMA_FAILURE',

  FETCH_USER_LIST_REQUEST: 'FETCH_USER_LIST_REQUEST',
  FETCH_USER_LIST_SUCCESS: 'FETCH_USER_LIST_SUCCESS',
  FETCH_USER_LIST_FAILURE: 'FETCH_USER_LIST_FAILURE',

  FETCH_TECH_OWNER_LIST_REQUEST: 'FETCH_TECH_OWNER_LIST_REQUEST',
  FETCH_TECH_OWNER_LIST_SUCCESS: 'FETCH_TECH_OWNER_LIST_SUCCESS',
  FETCH_TECH_OWNER_LIST_FAILURE: 'FETCH_TECH_OWNER_LIST_FAILURE',

  REFRESH_WITH_DIFF_REQUEST: 'DD_REFRESH_WITH_DIFF_REQUEST',
  REFRESH_WITH_DIFF_SUCCESS: 'DD_REFRESH_WITH_DIFF_SUCCESS',
  REFRESH_WITH_DIFF_FAILURE: 'DD_REFRESH_WITH_DIFF_FAILURE',

  LOAD_PENDING_CHANGES_REQUEST: 'DD_LOAD_PENDING_CHANGES_REQUEST',
  LOAD_PENDING_CHANGES_SUCCESS: 'DD_LOAD_PENDING_CHANGES_SUCCESS',
  LOAD_PENDING_CHANGES_FAILURE: 'DD_LOAD_PENDING_CHANGES_FAILURE',

  WORKFLOW_ACTION_REQUEST: 'DD_WORKFLOW_ACTION_REQUEST',
  WORKFLOW_ACTION_SUCCESS: 'DD_WORKFLOW_ACTION_SUCCESS',
  WORKFLOW_ACTION_FAILURE: 'DD_WORKFLOW_ACTION_FAILURE',

  ROLLBACK_CHANGE_REQUEST_REQUEST: 'DD_ROLLBACK_CHANGE_REQUEST_REQUEST',
  ROLLBACK_CHANGE_REQUEST_SUCCESS: 'DD_ROLLBACK_CHANGE_REQUEST_SUCCESS',
  ROLLBACK_CHANGE_REQUEST_FAILURE: 'DD_ROLLBACK_CHANGE_REQUEST_FAILURE',

  LOAD_ROLLBACK_HISTORY_REQUEST: 'DD_LOAD_ROLLBACK_HISTORY_REQUEST',
  LOAD_ROLLBACK_HISTORY_SUCCESS: 'DD_LOAD_ROLLBACK_HISTORY_SUCCESS',
  LOAD_ROLLBACK_HISTORY_FAILURE: 'DD_LOAD_ROLLBACK_HISTORY_FAILURE',

  REVIEW_CHANGE_REQUEST_REQUEST: 'DD_REVIEW_CHANGE_REQUEST_REQUEST',
  REVIEW_CHANGE_REQUEST_SUCCESS: 'DD_REVIEW_CHANGE_REQUEST_SUCCESS',
  REVIEW_CHANGE_REQUEST_FAILURE: 'DD_REVIEW_CHANGE_REQUEST_FAILURE',

  UPDATE_COLUMN_PII_REQUEST: 'DD_UPDATE_COLUMN_PII_REQUEST',
  UPDATE_COLUMN_PII_SUCCESS: 'DD_UPDATE_COLUMN_PII_SUCCESS',
  UPDATE_COLUMN_PII_FAILURE: 'DD_UPDATE_COLUMN_PII_FAILURE',

  LOAD_MISSING_REQUEST: 'DD_LOAD_MISSING_REQUEST',
  LOAD_MISSING_SUCCESS: 'DD_LOAD_MISSING_SUCCESS',
  LOAD_MISSING_FAILURE: 'DD_LOAD_MISSING_FAILURE',

  PREVIEW_MISSING_ATTRIBUTES_REQUEST: 'DD_PREVIEW_MISSING_ATTRIBUTES_REQUEST',
  PREVIEW_MISSING_ATTRIBUTES_SUCCESS: 'DD_PREVIEW_MISSING_ATTRIBUTES_SUCCESS',
  PREVIEW_MISSING_ATTRIBUTES_FAILURE: 'DD_PREVIEW_MISSING_ATTRIBUTES_FAILURE',

  IMPORT_MISSING_REQUEST: 'DD_IMPORT_MISSING_REQUEST',
  IMPORT_MISSING_SUCCESS: 'DD_IMPORT_MISSING_SUCCESS',
  IMPORT_MISSING_FAILURE: 'DD_IMPORT_MISSING_FAILURE',
};

const auth = new Auth();
const {getAccessToken} = auth;

// --------- Get Full Schema -----------
const OBJECT_KEYS = ['tables', 'views', 'storedProcedures'];

/**
 * Load the selectable objects for one or more schemas.
 *
 * MS SQL Server imports several schemas of one database together. Each schema is a
 * separate request, and against a real server each takes seconds — so every one
 * reports itself as it lands (GET_FULL_SCHEMA_PROGRESS) rather than the whole set
 * going dark behind one spinner. The merged result is still dispatched once at the
 * end, because the reducer holds a single fullSchemaData.
 *
 * A schema that fails does not cancel the others: the rest still load and are
 * listed, and the failed one is reported against its own name so the wizard can
 * name it and block Next.
 *
 * @param {string|number} dbConnectionId
 * @param {string|string[]} schemaName   one schema, or several
 * @param {string} [databaseName]        connection target; defaults to the schema
 */
export function getFullSchema(dbConnectionId, schemaName, databaseName) {
  const schemas = (Array.isArray(schemaName) ? schemaName : [schemaName]).filter(Boolean);

  return function(dispatch) {
    // Seed the checklist so every selected schema has a row from the first frame.
    dispatch({type: dataDictionaryActions.GET_FULL_SCHEMA_REQUEST, payload: {schemas}});

    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': getAccessToken(),
    };

    const countsOf = (response) => OBJECT_KEYS.reduce((acc, key) => {
      acc[key] = ((response && response[key]) || []).length;
      return acc;
    }, {});

    // Resolves to {schema, response} or {schema, error} — never rejects, so one
    // failing schema cannot take the others down with it.
    const requestFor = (schema) => {
      const queryParams = new URLSearchParams({dbConnectionId});
      if (schema) queryParams.set('schemaName', schema);
      if (databaseName) queryParams.set('databaseName', databaseName);

      return axios
          .get(process.env.REACT_APP_API_URL + '/manageDb/getSchemaObjects?' + queryParams.toString(), {headers})
          .then((res) => res.data)
          .then((json) => {
            if (json && json.status === false) {
              throw new Error(json.error || 'Could not read this schema');
            }
            const response = (json && json.response) || {};
            dispatch({
              type: dataDictionaryActions.GET_FULL_SCHEMA_PROGRESS,
              payload: {schema, status: 'done', counts: countsOf(response)},
            });
            return {schema, response};
          })
          .catch((error) => {
            const message = error?.response?.data?.error || error?.message || 'Could not read this schema';
            dispatch({
              type: dataDictionaryActions.GET_FULL_SCHEMA_PROGRESS,
              payload: {schema, status: 'error', error: message},
            });
            return {schema, error: message};
          });
    };

    Promise.all((schemas.length > 0 ? schemas : [undefined]).map(requestFor))
        .then((results) => {
          // Tag every object with the schema it came from, so the wizard can group
          // by schema and the import payload can route objects to the right
          // dd_schema_registry row.
          const merged = {tables: [], views: [], storedProcedures: []};
          results.filter((r) => !r.error).forEach(({schema, response}) => {
            OBJECT_KEYS.forEach((key) => {
              ((response && response[key]) || []).forEach((item) => {
                merged[key].push(schema && !item.schema ? {...item, schema} : item);
              });
            });
          });

          const failures = results.filter((r) => r.error);

          // Still SUCCESS when some schemas worked, so their objects remain visible
          // and the checklist keeps its green rows. failedSchemas is what blocks Next.
          dispatch({
            type: dataDictionaryActions.GET_FULL_SCHEMA_SUCCESS,
            payload: {
              status: true,
              response: merged,
              error: '',
              failedSchemas: failures.map((f) => ({schema: f.schema, error: f.error})),
            },
          });
        })
        .catch((error) => dispatch({
          type: dataDictionaryActions.GET_FULL_SCHEMA_FAILURE,
          payload: error,
          error: true,
        }));
  };
}

// --------- Get Schema (Tables + Columns only) -----------
export function getSchema(dbConnectionId) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.GET_SCHEMA_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/manageDb/getSchema?dbConnectionId=' + dbConnectionId, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({
          type: dataDictionaryActions.GET_SCHEMA_SUCCESS,
          payload: json,
        }))
        .catch((error) => dispatch({
          type: dataDictionaryActions.GET_SCHEMA_FAILURE,
          payload: error,
          error: true,
        }));
  };
}

// --------- Save Dictionary -----------
export function saveDictionary(data) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.SAVE_DICTIONARY_REQUEST});
    axios.post(process.env.REACT_APP_API_URL + '/dataDictionary/save', data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({
          type: dataDictionaryActions.SAVE_DICTIONARY_SUCCESS,
          payload: json,
        }))
        .catch((error) => dispatch({
          type: dataDictionaryActions.SAVE_DICTIONARY_FAILURE,
          payload: error,
          error: true,
        }));
  };
}

// --------- Load Dictionary List -----------
export function loadDictionaryList() {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.LOAD_DICTIONARY_LIST_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/instances', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => {
          console.log('ACTION - loadDictionaryList response:', response.data);

          // Check if the API returned success status
          if (response.data && response.data.status === false) {
            throw new Error(response.data.error || 'Failed to load dictionary list');
          }

          return response.data;
        })
        .then((json) => {
          dispatch({
            type: dataDictionaryActions.LOAD_DICTIONARY_LIST_SUCCESS,
            payload: json,
          });
        })
        .catch((error) => {
          console.error('ACTION - loadDictionaryList - API error:', error);
          dispatch({
            type: dataDictionaryActions.LOAD_DICTIONARY_LIST_FAILURE,
            payload: error,
            error: true,
          });
        });
  };
}

// --------- Delete Dictionary -----------
export function deleteDictionary(instanceId) {
  return function(dispatch) {
    console.log('=== DELETE DICTIONARY ACTION CALLED ===');
    console.log('instanceId:', instanceId);
    console.log('API URL:', process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId);

    dispatch({type: dataDictionaryActions.DELETE_DICTIONARY_REQUEST});

    axios.delete(process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => {
          console.log('ACTION - Raw delete response:', response);
          console.log('Response status:', response.status);
          console.log('Response data:', response.data);

          // Check if the API returned success status
          if (response.data && response.data.status === false) {
            // API returned an error
            throw new Error(response.data.error || 'Failed to delete dictionary');
          }

          dispatch({
            type: dataDictionaryActions.DELETE_DICTIONARY_SUCCESS,
            payload: response.data,
          });
        })
        .catch((error) => {
          console.error('ACTION - deleteDictionary - API error:', error);
          console.error('Error response:', error.response);
          console.error('Error message:', error.message);
          dispatch({
            type: dataDictionaryActions.DELETE_DICTIONARY_FAILURE,
            payload: error,
            error: true,
          });
        });
  };
}

// --------- Load Dictionary Details -----------
export function loadDictionaryDetails(instanceId) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.LOAD_DICTIONARY_DETAILS_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId +'/details', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => {
          console.log('ACTION - loadDictionaryDetails - API response:', response.data);

          // Check if the API returned success status
          if (response.data && response.data.status === false) {
            throw new Error(response.data.error || 'Failed to load dictionary details');
          }

          return response.data;
        })
        .then((json) => {
          dispatch({
            type: dataDictionaryActions.LOAD_DICTIONARY_DETAILS_SUCCESS,
            payload: json,
          });
        })
        .catch((error) => {
          console.error('ACTION - loadDictionaryDetails - API error:', error);
          dispatch({
            type: dataDictionaryActions.LOAD_DICTIONARY_DETAILS_FAILURE,
            payload: error,
            error: true,
          });
        });
  };
}

// --------- Update Dictionary Instance -----------
export function updateDictionaryInstance(instanceId, data) {
  return function(dispatch) {
    console.log('=== UPDATE DICTIONARY INSTANCE ACTION CALLED ===');
    console.log('instanceId:', instanceId);
    console.log('data:', data);
    console.log('API URL:', process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId);

    dispatch({type: dataDictionaryActions.UPDATE_DICTIONARY_INSTANCE_REQUEST});

    axios.post(process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => {
          console.log('ACTION - Raw axios response:', response);
          console.log('Response data:', response.data);

          // Check if the API returned success status
          if (response.data && response.data.status === false) {
            // API returned an error
            throw new Error(response.data.error || 'Failed to update dictionary');
          }

          dispatch({
            type: dataDictionaryActions.UPDATE_DICTIONARY_INSTANCE_SUCCESS,
            payload: response.data,
          });
        })
        .catch((error) => {
          console.error('ACTION - updateDictionaryInstance - API error:', error);
          console.error('Error response:', error.response);
          console.error('Error message:', error.message);
          dispatch({
            type: dataDictionaryActions.UPDATE_DICTIONARY_INSTANCE_FAILURE,
            payload: error,
            error: true,
          });
        });
  };
}

// --------- Import Schema (Save Data Dictionary) -----------
export function importSchema(data) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.IMPORT_SCHEMA_REQUEST});
    axios.post(process.env.REACT_APP_API_URL + '/dataDictionary/importSchema', data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => {
          // Check if the API returned success status
          if (response.data && response.data.status === false) {
            throw new Error(response.data.error || 'Failed to import schema');
          }

          return response.data;
        })
        .then((json) => {
          dispatch({
            type: dataDictionaryActions.IMPORT_SCHEMA_SUCCESS,
            payload: json,
          });
        })
        .catch((error) => dispatch({
          type: dataDictionaryActions.IMPORT_SCHEMA_FAILURE,
          payload: error,
          error: true,
        }));
  };
}

// --------- Fetch User List -----------
export function fetchUserList() {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.FETCH_USER_LIST_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/ownerCandidates?groupType=business', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => {
          dispatch({
            type: dataDictionaryActions.FETCH_USER_LIST_SUCCESS,
            payload: response.data,
          });
        })
        .catch((error) => {
          console.error('ACTION - fetchUserList - API error:', error);
          dispatch({
            type: dataDictionaryActions.FETCH_USER_LIST_FAILURE,
            payload: error,
            error: true,
          });
        });
  };
}

// --------- Fetch Tech Owner List -----------
export function fetchTechOwnerList() {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.FETCH_TECH_OWNER_LIST_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/ownerCandidates?groupType=technical', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => {
          dispatch({
            type: dataDictionaryActions.FETCH_TECH_OWNER_LIST_SUCCESS,
            payload: response.data,
          });
        })
        .catch((error) => {
          console.error('ACTION - fetchTechOwnerList - API error:', error);
          dispatch({
            type: dataDictionaryActions.FETCH_TECH_OWNER_LIST_FAILURE,
            payload: error,
            error: true,
          });
        });
  };
}

// --------- Refresh with Diff -----------
export function refreshWithDiff(instanceId) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.REFRESH_WITH_DIFF_REQUEST});
    axios.post(process.env.REACT_APP_API_URL + '/workflow/dataDictionary/instance/' + instanceId + '/refresh-with-diff', {}, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.REFRESH_WITH_DIFF_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.REFRESH_WITH_DIFF_FAILURE, payload: error, error: true}));
  };
}

// --------- Load Pending Changes -----------
export function loadPendingChanges(instanceId) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.LOAD_PENDING_CHANGES_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/workflow/changes?instanceId=' + instanceId + '&status=PENDING&limit=200', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.LOAD_PENDING_CHANGES_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.LOAD_PENDING_CHANGES_FAILURE, payload: error, error: true}));
  };
}

// --------- Rollback Change Request -----------
export function rollbackChangeRequest(requestId, reason) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.ROLLBACK_CHANGE_REQUEST_REQUEST});
    axios.post(process.env.REACT_APP_API_URL + '/workflow/changes/' + requestId + '/rollback',
        {reason},
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': getAccessToken(),
          },
        },
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.ROLLBACK_CHANGE_REQUEST_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.ROLLBACK_CHANGE_REQUEST_FAILURE, payload: error, error: true}));
  };
}

// --------- Load Rollback History -----------
export function loadRollbackHistory(requestId) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.LOAD_ROLLBACK_HISTORY_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/workflow/changes/' + requestId + '/rollback-history', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.LOAD_ROLLBACK_HISTORY_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.LOAD_ROLLBACK_HISTORY_FAILURE, payload: error, error: true}));
  };
}
export function applyWorkflowAction(requestId, action, comments) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.WORKFLOW_ACTION_REQUEST});
    axios.post(process.env.REACT_APP_API_URL + '/workflow/changes/' + requestId + '/action',
        {action, comments},
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': getAccessToken(),
          },
        },
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.WORKFLOW_ACTION_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.WORKFLOW_ACTION_FAILURE, payload: error, error: true}));
  };
}

// --------- Update Column isPii -----------
export function updateColumnIsPii(columnId, isPii) {
  return function(dispatch) {
    return axios.put(process.env.REACT_APP_API_URL + '/dataDictionary/column/' + columnId,
        {isPii},
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': getAccessToken(),
          },
        },
    );
  };
}

// --------- Update Column isAiEligible -----------
export function updateColumnIsAiEligible(columnId, isAiEligible) {
  return function(dispatch) {
    return axios.put(process.env.REACT_APP_API_URL + '/dataDictionary/column/' + columnId,
        {isAiEligible},
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': getAccessToken(),
          },
        },
    );
  };
}

// --------- Review Change Request (Approve / Reject) -----------
export function reviewChangeRequest(requestId, data) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.REVIEW_CHANGE_REQUEST_REQUEST});
    axios.put(process.env.REACT_APP_API_URL + '/dataDictionary/changeRequest/' + requestId + '/review', data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.REVIEW_CHANGE_REQUEST_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.REVIEW_CHANGE_REQUEST_FAILURE, payload: error, error: true}));
  };
}

// --------- Update Column PII -----------
export function updateColumnPii(columnId, isPii) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.UPDATE_COLUMN_PII_REQUEST});
    axios.put(process.env.REACT_APP_API_URL + '/dataDictionary/column/' + columnId, {isPii}, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.UPDATE_COLUMN_PII_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.UPDATE_COLUMN_PII_FAILURE, payload: error, error: true}));
  };
}

// --------- Load Missing Objects / Attributes -----------
export function loadMissingObjects(instanceId) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.LOAD_MISSING_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId + '/missing', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.LOAD_MISSING_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.LOAD_MISSING_FAILURE, payload: error, error: true}));
  };
}

// --------- Preview Missing Attributes for selected missing objects -----------
export function previewMissingAttributes(instanceId, selectedMissingObjects) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.PREVIEW_MISSING_ATTRIBUTES_REQUEST});
    axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId + '/missing', {
      params: {
        selectedMissingObjects: JSON.stringify(selectedMissingObjects || []),
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getAccessToken(),
      },
    })
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.PREVIEW_MISSING_ATTRIBUTES_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.PREVIEW_MISSING_ATTRIBUTES_FAILURE, payload: error, error: true}));
  };
}

// --------- Import Selected Missing Objects / Attributes -----------
export function importMissingObjects(instanceId, payload) {
  return function(dispatch) {
    dispatch({type: dataDictionaryActions.IMPORT_MISSING_REQUEST});
    axios.post(
        process.env.REACT_APP_API_URL + '/dataDictionary/instance/' + instanceId + '/import-missing',
        payload,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': getAccessToken(),
          },
        },
    )
        .then((response) => response.data)
        .then((json) => dispatch({type: dataDictionaryActions.IMPORT_MISSING_SUCCESS, payload: json}))
        .catch((error) => dispatch({type: dataDictionaryActions.IMPORT_MISSING_FAILURE, payload: error, error: true}));
  };
}
